export const JuniorClasses = [
    {
        name:"JSS 1",
        code: "FGJSC_001",
        id: "001"
    },
    {
        name:"JSS 2",
        code: "FGJSC_002",
        id: "002"
    },
    {
        name:"JSS 3",
        code: "FGJSC_003",
        id: "003"
    },
]

export const SeniorClasses = [
    {
        name:"JSS 1",
        code: "FGSSC_001",
        id: "001"
    },
    {
        name:"JSS 2",
        code: "FGSSC_002",
        id: "002"
    },
    {
        name:"JSS 3",
        code: "FGSSC_003",
        id: "003"
    },
]

export const BasicClasses = [
    {
        name:"BASIC 1",
        code: "FGBSC_001",
        id: "001"
    },
    {
        name:"BASIC 2",
        code: "FGBSC_002",
        id: "002"
    },
    {
        name:"BASIC 3",
        code: "FGBSC_003",
        id: "003"
    },
    {
        name:"BASIC 4",
        code: "FGBSC_004",
        id: "004"
    },
    {
        name:"BASIC 5",
        code: "FGBSC_005",
        id: "005"
    },
    {
        name:"BASIC 6",
        code: "FGBSC_006",
        id: "006"
    },
]

export const KgClasses=[
    {
        name:"KG 1",
        code: "FGKGC_001",
        id: "001"
    },
    {
        name:"KG 2",
        code: "FGKGC_002",
        id: "002"
    },
]
export const NurseryClasses=[
    {
        name:"KG 1",
        code: "FGNSC_001",
        id: "001"
    },
    {
        name:"KG 2",
        code: "FGNSC_002",
        id: "002"
    },
]